<template>
  <SharingView
    @itemAdded="itemAdded"
    @itemRemoved="itemRemoved"
    @permissionChanged="permissionChanged"
    @isLoading="updateSharingLoading"
    :permittedActorsListTitle="$t('sharing.currentSharing', {resource:'envelope'})"
    :resource="envelope"
    v-model="sharingSettings" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { logAmplitudeEvent } from '@/utils/analytics';
import SharingView from '@/components/Sharing.vue';

export default {
  components: {
    SharingView,
  },
  props: {
    updatingEnvelope: {
      type: Object,
      required: false,
    },
  },

  async mounted() {
    this.emitInterface();
    this.sharingSettings = this.initialSharingSettings;
  },

  data() {
    return {
      isLoading: false,
      sharingSettings: {},
    };
  },
  computed: {
    ...mapGetters({
      creatingEnvelope: 'envelopes/creating',
    }),
    envelope() {
      return this.updatingEnvelope ? this.updatingEnvelope : this.creatingEnvelope;
    },
    initialSharingSettings() {
      return { ...this.envelope.sharing, everyone_permission: this.envelope.everyone_permission };
    },
  },
  methods: {
    ...mapActions({
      updateEnvelope: 'envelopes/UPDATE_ENVELOPE',
    }),
    emitInterface() {
      this.$emit('interface', {
        save: async () => this.save(),
      });
    },
    updateSharingLoading(loading) {
      this.$emit('isLoading', loading);
    },
    itemAdded(item) {
      logAmplitudeEvent('envelope_sharing--added_actor_to_envelope_sharing', { type: item.type });
    },
    itemRemoved(item) {
      logAmplitudeEvent('envelope_sharing--removed_actor_from_envelope_sharing', { type: item.type });
    },
    permissionChanged(value) {
      logAmplitudeEvent('envelope_sharing--permission_changed', { type: value.slug });
    },
    async save() {
      this.isLoading = true;

      try {
        await this.updateEnvelope({
          fingerprint: this.envelope.fingerprint,
          data: { sharing: this.sharingSettings },
        });
        this.$emit('sharingUpdated', this.sharingSettings);
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('message.fail.update', { name: 'envelope' }),
          icon: 'times',
          type: 'error',
        }));
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    isLoading(newValue) {
      this.$emit('isLoading', newValue);
    },
  },


};
</script>
